import type { Swiper, SwiperEvents } from "swiper/types";

export const TallestSlideModule = ({
    swiper,
    on,
}: {
    swiper: Swiper;
    on: <E extends keyof SwiperEvents>(
        event: E,
        handler: SwiperEvents[E],
    ) => void;
}) => {
    let frame = 0;
    const observedSwiper = swiper as Swiper & { __preventObserver__?: boolean };

    function getSlides() {
        return Array.from(swiper.slides).filter((slide) => {
            return !slide.classList.contains("swiper-slide-duplicate");
        }) as HTMLElement[];
    }

    function setTallestHeight() {
        const slides = getSlides();

        let maxHeight = 0;

        // Changing the inline heights must not feed back into Swiper's
        // MutationObserver and schedule this module again.
        observedSwiper.__preventObserver__ = true;

        slides.forEach((slide) => {
            slide.style.height = "";
        });

        slides.forEach((slide) => {
            const height = slide.scrollHeight;

            if (height > maxHeight) {
                maxHeight = height;
            }
        });

        if (maxHeight) {
            swiper.slides.forEach((slide: HTMLElement) => {
                slide.style.height = `${maxHeight}px`;
            });
        }

        requestAnimationFrame(() => {
            observedSwiper.__preventObserver__ = false;
        });
    }

    function scheduleTallestHeight() {
        cancelAnimationFrame(frame);

        frame = requestAnimationFrame(() => {
            frame = requestAnimationFrame(setTallestHeight);
        });
    }

    on("afterInit", scheduleTallestHeight);
    on("resize", scheduleTallestHeight);
    on("breakpoint", scheduleTallestHeight);
    on("observerUpdate", scheduleTallestHeight);
    on("update", scheduleTallestHeight);
};
